import React from 'react';
import { ShadowBox } from './Privacy.style';
import PrivacyWrapper from './PrivacyContainer';
import { Helmet } from 'react-helmet';

export default function AboutUs({ isLoggedIn, hideBackArrow, isAuthPage }) {
  return (
    <>
      <Helmet>
        <title>About Us | WafyNet - Learn About Our Mission</title>
        <meta
          name="description"
          content="Learn about WafyNet, our mission, our community values, and how we help users connect, grow businesses, and find opportunities."
        />
      </Helmet>
      <PrivacyWrapper
        isLoggedIn={isLoggedIn}
        hideBackArrow={hideBackArrow}
        isAuthPage={isAuthPage}
      >
        <ShadowBox isauthpage={isAuthPage}>
          <h3>About Us</h3>
          <p>
            <strong>WafyNet</strong> is a next-generation digital platform that
            combines the power of a social media site and a job site, designed
            to connect people, businesses, and opportunities through a
            comprehensive ecosystem. It enables users to network, explore career
            opportunities, grow their businesses, and access a wide range of
            services — all in one place.
          </p>
          <p>
            Founded on <strong>March 1, 2025</strong> by{' '}
            <strong>MR Couple</strong> —<b>M</b>alar and <b>R</b>anjith —
            WafyNet’s vision is to create a global platform that empowers
            collaboration, career growth, and community building.
          </p>
          <p>
            In addition, WafyNet provides end-to-end IT services including
            software development, UI/UX design, testing, and maintenance. Our
            commitment is to deliver innovative, reliable, and user-focused
            solutions that help individuals and organizations thrive in the
            digital era.
          </p>
          <p>
            For inquiries, partnerships, or support, please contact us at
            <a href="mailto:support@wafynet.com"> support@wafynet.com</a>.
          </p>
        </ShadowBox>
      </PrivacyWrapper>
    </>
  );
}
